import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export interface Autor{
  auth_key:string,
  data:[{
    id:number,
    nombre:string,
    descripcion:string
  }]
}

@Injectable({
  providedIn: 'root'
})
export class AutorService {

  constructor(private http: HttpClient) { }

  getAll(id){
    var headers = new HttpHeaders();
    const options = {headers: headers,withCredintials: false };
    let postData = [];
    postData.push({'auth_key':id});
    return this.http.post<Autor>(environment.urlAutores+'?opcion=1', JSON.stringify(postData));
  }
}
